<!-- display addToOrderTemplate Icon/animated Icon or link-->
@if (visible$ | async) {
<button
  type="button"
  name="addProduct"
  class="add-to-order btn rounded-circle"
  [disabled]="disabled$ | async"
  [ngClass]="cssClass"
  [title]="
    displayType === 'icon' ? ('account.order_template.add_to_template.button.add_to_template.label' | translate) : ''
  "
  [tabindex]="ariaHidden ? -1 : 0"
  [attr.aria-hidden]="ariaHidden"
  (click)="openModal(modal)"
  data-testing-id="addToOrderTemplateButton"
  title="{{ 'account.order_template.add_to_template.button.add_to_template.label' | translate }}"
>
  @switch (displayType) { @case ('animated') {
  <!-- <fa-icon
        [icon]="['fas', 'heart']"
        [title]="'account.order_template.add_to_template.button.add_to_template.label' | translate"
      ></fa-icon> -->
  <i class="icon-heart"></i>
  <span class="share-label">{{
    'account.order_template.add_to_template.button.add_to_template.label' | translate
  }}</span>
  } @case ('icon') {
  <!-- <fa-icon
      [icon]="['fas', 'heart']"
      [title]="'account.order_template.add_to_template.button.add_to_template.label' | translate"
    ></fa-icon> -->
  <i
    class="icon-heart"
    title="{{ 'account.order_template.add_to_template.button.add_to_template.label' | translate }}"
  ></i>
  } @default {
  {{ 'account.order_template.add_to_template.button.add_to_template.label' | translate }}
  } }
</button>
}

<ish-select-order-template-modal #modal (submitEmitter)="addProductToOrderTemplate($event)" />
